import React, { FC } from "react";
import SubscriptionCardButton from "./SubscriptionCardButton";
import BetaPlanExpiredMsgComponent from "./BetaPlanExpiredMsgComponent";

type PropsType = {
  isDisplayNotPlan: any;
  daysRemaining?: any;
  productGuid?: string;
};

const NotSubscribedIllustration: FC = () => (
  <svg
    className="ni-dash-empty-illu"
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="60" cy="60" r="50" fill="var(--ni-dash-brand-tint)" />

    {/* Card stack */}
    <rect x="32" y="42" width="48" height="58" rx="7"
          fill="var(--ni-dash-surface-2)"
          stroke="var(--ni-dash-line)" strokeWidth="1.5"
          transform="rotate(-6 56 71)" />
    <rect x="40" y="34" width="48" height="58" rx="7"
          fill="var(--ni-dash-surface)"
          stroke="var(--ni-dash-brand)" strokeWidth="1.5" />

    {/* Detail lines on front card */}
    <line x1="48" y1="48" x2="80" y2="48" stroke="var(--ni-dash-brand)" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="48" y1="58" x2="72" y2="58" stroke="var(--ni-dash-ink-3)" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    <line x1="48" y1="65" x2="78" y2="65" stroke="var(--ni-dash-ink-3)" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    <line x1="48" y1="72" x2="68" y2="72" stroke="var(--ni-dash-ink-3)" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    <circle cx="64" cy="84" r="4" fill="var(--ni-dash-brand)" />

    {/* Sparkles */}
    <circle className="spark"   cx="22" cy="28" r="2.4" fill="var(--ni-dash-brand)" />
    <circle className="spark spark-2" cx="98" cy="32" r="3.2" fill="var(--ni-dash-brand-3)" />
    <circle className="spark spark-3" cx="102" cy="88" r="2.2" fill="var(--ni-dash-brand)" />
    <path className="spark spark-2"
          d="M 18 88 l 1.5 -3 l 1.5 3 l 3 1.5 l -3 1.5 l -1.5 3 l -1.5 -3 l -3 -1.5 z"
          fill="var(--ni-dash-brand-3)" />
  </svg>
);

const BetaPlanDaysRemainNotSubscribedPlanBanner: FC<PropsType> = ({
  isDisplayNotPlan,
  daysRemaining,
  productGuid,
}) => {
  const isExpiredOrUrgent =
    !isDisplayNotPlan && (daysRemaining < 0 || daysRemaining <= 0);

  return (
    <div className="ni-dash-cockpit ni-dash-cockpit--empty">
      <div className="ni-dash-empty-content">
        <NotSubscribedIllustration />
        <div
          className={`ni-dash-empty-message ${
            isExpiredOrUrgent ? "ni-dash-empty-message--danger" : ""
          }`}
        >
          {isDisplayNotPlan ? (
            <>
              You&rsquo;re not subscribed yet.
              <br />
              Pick a plan to <strong>get started</strong>.
            </>
          ) : (
            <BetaPlanExpiredMsgComponent daysRemaining={daysRemaining} />
          )}
        </div>
      </div>

      <div className="ni-dash-cockpit-actions">
        <SubscriptionCardButton
          buttonTypeIsSubscribe={isDisplayNotPlan}
          havePlan={!isDisplayNotPlan}
          productGuid={productGuid}
        />
      </div>
    </div>
  );
};

export default BetaPlanDaysRemainNotSubscribedPlanBanner;
